import EtablissementSiret from '@/generated/controls/etablissement/EtablissementSiret.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementSiret
})
